const PAGE_TITLES: Record<string, string> = {
  '/': 'Login',
  '/login': 'Login',
  '/login/details': 'Login',
  '/login/google': 'Login',
  '/cadastro': 'Complete seus dados',
  '/cadastro/email/[token]': 'Completar Cadastro',
  '/cadastro/b2b/confirmacao-por-email-enviada': 'Verifique seu E-mail',
  '/cadastro/b2b/email/[token]': 'Completar Cadastro',
  '/cadastro/confirmacao-por-email-enviada': 'Verifique seu E-mail',
  '/cadastro/confirmacao-por-codigo': 'Confirme seu e-mail',
  '/cadastro/cpf': 'Complete seus dados',
  '/cadastro/cpf/erro': 'CPF não verificado',
  '/cadastro/verificar-email-app/[token]': 'E-mail verificado',
  '/cadastro/erro-de-limite-de-tentativas': 'Limite de contas excedido',
  '/recuperar-senha': 'Recuperar senha',
  '/recuperar-senha/[token]': 'Redefinir senha',
  '/resetar-senha/[token]': 'Redefinir senha',
  '/sso/erro': 'Erro ao Associar Conta',
}

export function getPageTitle(pathname: string): string {
  const title = PAGE_TITLES[pathname]
  return title ? `${title} | Jusbrasil` : 'Jusbrasil'
}
